export const CUSTOMER_CATEGORY = {
    GET_ALL: '/customer-category',
    CREATE: '/customer-category/create',
    UPDATE: '/customer-category/update',
    DELETE: '/customer-category/delete',
};
